import { Link } from "react-router-dom";

import { DESIGN_PARTNER_PATHS } from "../routes";

export function TermsPage() {
  return (
    <section className="page" id="terms" data-testid="dp-page-terms">
      <div className="wrap policy">
        <div className="eyebrow">Legal</div>
        <h1>Terms of Use</h1>
        <p>
          <b>Effective date:</b> August 10, 2026
        </p>
        <div className="notice">This draft should be reviewed by legal counsel before production use.</div>
        <h2>Purpose of this site</h2>
        <p>
          This website describes Zephix and permits visitors to request a design-partner
          conversation. It does not create a customer relationship, guarantee access to software, or
          promise any specific release date or functionality.
        </p>
        <h2>Acceptable use</h2>
        <p>
          You may use this site for lawful business evaluation. You may not interfere with the site,
          attempt unauthorized access, submit misleading information, scrape the site at scale, or use
          site content to build or market a competing service.
        </p>
        <h2>Product direction</h2>
        <p>
          Product illustrations, descriptions, and roadmaps describe current direction and may
          change. They are not commitments to deliver a feature, integration, timeline, or service
          level.
        </p>
        <h2>Intellectual property</h2>
        <p>
          The Zephix name, site content, design, and materials are owned by Zephix or its licensors.
          You may not reproduce or reuse them without permission.
        </p>
        <h2>Disclaimers</h2>
        <p>
          The site is provided on an “as is” and “as available” basis. To the maximum extent
          permitted by law, Zephix disclaims warranties regarding availability, accuracy,
          merchantability, fitness for a particular purpose, and non-infringement.
        </p>
        <h2>Contact</h2>
        <p>
          For questions about these terms, use the <Link to={DESIGN_PARTNER_PATHS.contact}>Contact page</Link>.
        </p>
      </div>
    </section>
  );
}
